import { rgba } from 'polished';
import styled from 'styled-components';

import { dropLineIndentSpacing, rowHeight } from './constants';

export const Line = styled.div<{ $depth: number }>`
  position: absolute;
  left: ${({ theme, $depth }) =>
    `calc(${theme.spacing(2.5)} + ${$depth} * ${theme.spacing(dropLineIndentSpacing)})`};
  right: ${({ theme }) => theme.spacing(2.5)};

  height: 2px;
  transform: translateY(-1px);

  border-radius: 1px;
  background: ${({ theme }) => theme.palette.info.main};
  pointer-events: none;
`;

export const NestHighlight = styled.div<{ $depth: number }>`
  position: absolute;
  left: ${({ theme, $depth }) =>
    `calc(${theme.spacing(2.5)} + ${$depth} * ${theme.spacing(2)})`};
  right: ${({ theme }) => theme.spacing(2.5)};

  height: ${rowHeight}px;

  border: 2px solid ${({ theme }) => theme.palette.info.main};
  border-radius: ${({ theme }) => theme.spacing(2)};
  background: ${({ theme }) => rgba(theme.palette.info.main, 0.06)};
  pointer-events: none;
`;
